module.exports = __webpack_public_path__ + "img/20201106_083755.224dc54c.jpg";